"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _widgetContainer = _interopRequireWildcard(require("@insided/deprecated-preact-components/widget-container"));

var _zod = require("zod");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var widgetName = 'community_statistics';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-community_statistics';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  total_topics: _zod.z.boolean(),
  total_comments: _zod.z.boolean(),
  total_users: _zod.z.boolean(),
  title: _zod.z.string()
}).merge(_widgetContainer.widgetContainerConfig);

exports.config = config;

var CommunityStatisticsWidget = function CommunityStatisticsWidget(_ref) {
  var config = _ref.config,
      topictotal = _ref.topictotal,
      reactiontotal = _ref.reactiontotal,
      membertotal = _ref.membertotal;
  var classNames = 'box widget widget--stats qa-widget-stats';
  return (0, _preact.h)(_widgetContainer.default, {
    widgetName: widgetName,
    config: config,
    className: classNames
  }, (0, _preact.h)("div", {
    className: "what-is-going-on qa-what-is-going-on"
  }, (0, _preact.h)("dl", {
    className: "dl--tabular qa-stats-table"
  }, topictotal ? (0, _preact.h)("dt", null, topictotal.toLocaleString()) : null, topictotal ? (0, _preact.h)("dd", null, (0, _preact.h)(_phrase.default, {
    m: "Common",
    p: "widget.whatIsGoingOn.statistics.topic"
  })) : null, reactiontotal ? (0, _preact.h)("dt", null, reactiontotal.toLocaleString()) : null, reactiontotal ? (0, _preact.h)("dd", null, (0, _preact.h)(_phrase.default, {
    m: "Common",
    p: "widget.whatIsGoingOn.statistics.reactions"
  })) : null, membertotal ? (0, _preact.h)("dt", null, membertotal.toLocaleString()) : null, membertotal ? (0, _preact.h)("dd", null, (0, _preact.h)(_phrase.default, {
    m: "Common",
    p: "widget.whatIsGoingOn.statistics.members"
  })) : null)));
};

var _default = CommunityStatisticsWidget;
exports.default = _default;